'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import a$1 from "../defs/CaretUp.js";
var f = Object.defineProperty, i = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (r, e, t) => e in r ? f(r, e, { enumerable: true, configurable: true, writable: true, value: t }) : r[e] = t, m = (r, e) => {
  for (var t in e || (e = {}))
    c.call(e, t) && a(r, t, e[t]);
  if (o)
    for (var t of o(e))
      n.call(e, t) && a(r, t, e[t]);
  return r;
}, p = (r, e) => i(r, s(e));
const I = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, p(m({ ref: e }, r), { weights: a$1 })));
I.displayName = "CaretUp";
export {
  I as CaretUp
};
